/* eslint-disable react-hooks/exhaustive-deps */
import { Table, Select, DatePicker } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

import { showErrorNotification } from "../../../../utils/notification";
import { clamp } from "../../../../utils/responsiveHelpers";
import { RATING_OPTIONS } from "../../helper";

const CPSheetProblemAnalyticsDash = ({ ROOT_URL }) => {
  const BASE_BACKEND_URL = "admin/cp-sheet/analytics/problem";

  const currentDate = new Date();
  const oneMonthAgo = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() - 1,
    currentDate.getDate()
  );

  // Filter States.
  const [filter, setFilter] = useState({
    startDate: oneMonthAgo,
    endDate: currentDate,
    rating: "All"
  });

  // Page states.
  const [problemsData, setProblemsData] = useState([]);

  const fetchProblemLevelAnalytics = () => {
    axios
      .get(`${ROOT_URL}/${BASE_BACKEND_URL}/analytics`, {
        params: {
          filter
        }
      })
      .then((res) => {
        const { problemsTableData } = res.data;
        setProblemsData(problemsTableData);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  useEffect(() => {
    fetchProblemLevelAnalytics();
  }, [filter]);

  const columns = [
    {
      title: "S. No",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Problem Name",
      dataIndex: "name",
      key: "name"
    },
    {
      title: "Problem Link",
      dataIndex: "link",
      key: "link"
    },
    {
      title: "Problem Rating",
      dataIndex: "rating",
      key: "rating"
    },
    {
      title: "Total Verified Count",
      dataIndex: "totalVerifiedSolvedCount",
      key: "totalVerifiedSolvedCount",
      sorter: (a, b) => a["totalVerifiedSolvedCount"] - b["totalVerifiedSolvedCount"]
    },
    {
      title: "Total Non-Verified Count",
      dataIndex: "totalNotVerifiedSolvedCount",
      key: "totalNotVerifiedSolvedCount",
      sorter: (a, b) => a["totalNotVerifiedSolvedCount"] - b["totalNotVerifiedSolvedCount"]
    },
    {
      title: "Total Count",
      dataIndex: "totalSolvedCount",
      key: "totalSolvedCount",
      sorter: (a, b) => a["totalSolvedCount"] - b["totalSolvedCount"]
    },
    {
      title: "Discussion Count",
      dataIndex: "discussionCount",
      key: "discussionCount",
      sorter: (a, b) => a["discussionCount"] - b["discussionCount"]
    }
  ];

  return (
    <div
      style={{
        marginTop: "20px",
        marginLeft: clamp(12, 30),
        marginRight: clamp(12, 30)
      }}
    >
      <div
        style={{
          marginBottom: "10px",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "5px",
          minHeight: "30px"
        }}
      >
        Date filter:{" "}
        <DatePicker.RangePicker
          style={{ width: "20%" }}
          value={
            filter.startDate && filter.endDate
              ? [dayjs(filter.startDate), dayjs(filter.endDate)]
              : []
          }
          onChange={(dates) => {
            if (dates) {
              setFilter((prevFilter) => ({
                ...prevFilter,
                startDate: dates[0].startOf("day").toDate(),
                endDate: dates[1].endOf("day").toDate()
              }));
            } else {
              setFilter((prevFilter) => ({
                ...prevFilter,
                startDate: null,
                endDate: null
              }));
            }
          }}
        />
        Rating:
        <Select
          placeholder="Select Rating"
          style={{ width: "min(200px, 100%)" }}
          onChange={(value) => {
            setFilter((prevFilter) => ({
              ...prevFilter,
              rating: value
            }));
          }}
        >
          {(RATING_OPTIONS || []).map((rating) => (
            <Select.Option value={rating} key={rating}>
              {rating}
            </Select.Option>
          ))}
        </Select>
      </div>
      <h3>
        Data is available from 17th, data before this date if required can be provided manually
      </h3>
      <p>
        <li>
          This is the total number of submissions on a problem by our verified CP sheet users.
        </li>
        <li>All the columns are controllable by dates.</li>
        <b>
          Note: Values here might not match with the total daily verified count or leaderboard
          because this data is also derived from users who do not own their CF handles but are
          impacting the problem level solved count due to the sync calls that they do.
        </b>
      </p>
      <Table
        dataSource={problemsData}
        columns={columns}
        bordered
        pagination={false}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
};

export default CPSheetProblemAnalyticsDash;
